export const supportedLanguages = [
  'ar',
  'bn',
  'ca',
  'cs',
  'da',
  'de',
  'el',
  'en',
  'es',
  'et',
  'eu',
  'fi',
  'fr',
  'hi',
  'hu',
  'id',
  'it',
  'ja',
  'kk',
  'kn',
  'lt',
  'lv',
  'mr',
  'ms',
  'nl',
  'no',
  'pa',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sl',
  'sq',
  'sv',
  'ta',
  'te',
  'th',
  'tr',
  'uk',
  'vi',
  'zh-Hans-CN',
  'zh-Hant-TW',
] as const

export type SupportedLanguage = (typeof supportedLanguages)[number]

const languageCodes = new Map<string, SupportedLanguage>(
  supportedLanguages.map(language => [language.toLowerCase(), language])
)

// Keep existing URLs and the language codes used by the native hosts working.
const aliases: Readonly<Record<string, SupportedLanguage>> = {
  zh: 'zh-Hant-TW',
  'zh-tw': 'zh-Hant-TW',
  'zh-hant': 'zh-Hant-TW',
  'zh-cn': 'zh-Hans-CN',
  'zh-hans': 'zh-Hans-CN',
  'en-us': 'en',
  'en-gb': 'en',
}

export const resolveLanguage = (value: string | null): SupportedLanguage => {
  const normalized = value?.trim().replace(/_/g, '-').toLowerCase() ?? ''
  return (
    languageCodes.get(normalized) ??
    (Object.prototype.hasOwnProperty.call(aliases, normalized)
      ? aliases[normalized]
      : 'en')
  )
}

export const getLanguageFromSearch = (search: string): SupportedLanguage =>
  resolveLanguage(new URLSearchParams(search).get('lang'))

export const getLanguageDirection = (language: SupportedLanguage) =>
  language === 'ar' ? 'rtl' : 'ltr'
